import { createContext } from '../../utils/create-context';
export const [LocaleContextProvider, useLocaleContext] = createContext({
    hookName: 'useEnvironmentContext',
    providerName: '<EnvironmentProvider />',
    strict: false,
    defaultValue: () => ({ dir: 'ltr', locale: 'en-US' }),
});
